import React, { useEffect, useState } from 'react';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { getProfile, updateProfile } from '../../components/Service/UserService';
import { useProfile } from '../../Context/ProfileContext';
import "./Profile.css"
import Spinner from 'react-bootstrap/Spinner';
import useLanguage from '../../Hooks/useLanguage';
import { useTranslation } from 'react-i18next';
function ProfileForm() {

    const [updateMessage, setUpdateMessage] = useState(""); // Thông báo trạng thái cập nhật
    useLanguage();

    const { profile, alertBalance, loading } = useProfile();
    const [balanceAlert, setBalanceAlert] = useState(profile?.balance_alert);
    const { t } = useTranslation();
    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        );
    }
    const handleUpdateProfile = async () => {
        const data = {
            name: document.getElementById("name").value || profile?.name,
            phone: document.getElementById("phone").value || profile?.phone,
            namebank: document.getElementById("namebank").value || profile?.namebank,
            numberbank: document.getElementById("numberbank").value || profile?.numberbank,
            cccd: document.getElementById("cccd").value || profile?.cccd,
            subemail1: document.getElementById("subemail1").value || profile?.subemail1,
            subemail2: document.getElementById("subemail2").value || profile?.subemail2,
            subemail3: document.getElementById("subemail3").value || profile?.subemail3,
            name_company: document.getElementById("name_company").value || profile?.name_company,
            taxcode: document.getElementById("taxcode").value || profile?.taxcode,
            address: document.getElementById("address").value || profile?.address,
            balance_alert: document.getElementById("balance_alert").value || profile?.balance_alert,
        };

        const response = await updateProfile(data);

        if (response) {
            window.location.reload();
            setUpdateMessage("Cập nhật thành công!");
        } else if (response.error || response.status != 200) {
            setUpdateMessage(response.message);
        }
    };

    return (
        <>

            <div className='row'>
                <div className='col-7'>
                    <div className="tab-content">
                        {" "}
                        <div className="tab-pane active show" id="tab_1" role="tabpanel">
                            <div className="box-content-tab-default">
                                {profile &&
                                    (
                                        <table className="table">
                                            <tbody>

                                                <tr>
                                                    <td className="text-bold">{t("Acount name")}</td>
                                                    <td>
                                                        <div className="flex-container">
                                                            <input
                                                                id='name'
                                                                className="form-control"
                                                                name="username"
                                                                required=""
                                                                disabled=""
                                                                placeholder={profile?.name}

                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-bold">{t("Phone number")}</td>
                                                    <td>
                                                        <div className="flex-container">
                                                            <input
                                                                className="form-control"
                                                                id="phone"
                                                                name="phone"
                                                                type='phone'
                                                                required=""
                                                                disabled=""
                                                                placeholder={profile?.phone}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-bold">Email</td>
                                                    <td>
                                                        <div className="flex-container">
                                                            {profile?.email ? (
                                                                <span className="placeholder-text">{profile?.email}</span>
                                                            ) : (
                                                                <span className="placeholder-text">Không có email</span>
                                                            )}
                                                            <input
                                                                className="form-control hidden-input"
                                                                id="email"
                                                                name="email"
                                                                required=""
                                                                disabled=""
                                                                style={{ display: "none" }}
                                                                placeholder={profile?.email}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="text-bold">{t("Account type")}</td>
                                                    <td>
                                                        <div className="flex-container">
                                                            <span className="">{t("Regular account")}</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-bold">{t("Status")}</td>
                                                    <td>
                                                        <div className="flex-container">
                                                            <span className={profile?.status === 0 ? "badge badge-danger" : "badge badge-success"}>
                                                                {profile?.status === 0 ? t("Inactive") : t("Active")}
                                                            </span>
                                                        </div>

                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-bold">{t("Createtion time")}</td>
                                                    <td>
                                                        <div className="flex-container">
                                                            <span className="">
                                                                {new Date(profile?.created_at).toLocaleDateString('vi-VN', {
                                                                    day: '2-digit',
                                                                    month: '2-digit',
                                                                    year: 'numeric'
                                                                })}
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>
                                                {/* <tr>
                                        <td className="text-bold">Đăng nhập lần cuối</td>
                                        <td>
                                            <div className="flex-container">
                                                <input
                                                    className="form-control"
                                                    name="last_login"
                                                    required=""
                                                    disabled=""
                                                />
                                            </div>
                                        </td>
                                    </tr> */}
                                                <tr>
                                                    <td className="text-bold">{t("Balance alert")}</td>
                                                    <td>
                                                        <div className="flex-container">
                                                            <input
                                                                id="balance_alert"
                                                                className="form-control"
                                                                name="balance_alert"
                                                                type='number'
                                                                min={alertBalance}
                                                                required=""
                                                                placeholder={profile?.balance_alert}
                                                                value={balanceAlert}
                                                                onChange={(e) => setBalanceAlert(e.target.value)}

                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-bold">{t("Bank account number")}</td>
                                                    <td>
                                                        <div className="flex-container">
                                                            <input
                                                                id="numberbank"
                                                                className="form-control"
                                                                name="numberbank"
                                                                required=""
                                                                disabled=""
                                                                placeholder={profile?.numberbank}

                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-bold">{t("Bank Information")}</td>
                                                    <td>
                                                        <div className="flex-container">
                                                            <input
                                                                id="namebank"
                                                                className="form-control"
                                                                name="namebank"
                                                                required=""
                                                                disabled=""
                                                                placeholder={profile?.namebank}

                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-bold">{t("CCCD number")}</td>
                                                    <td>
                                                        <div className="flex-container">
                                                            <input
                                                                id='cccd'
                                                                className="form-control"
                                                                name="cccd"
                                                                required=""
                                                                disabled=""
                                                                placeholder={profile?.cccd}

                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-bold">{t("Address")}</td>
                                                    <td>
                                                        <div className="flex-container">
                                                            <input
                                                                id='address'
                                                                className="form-control"
                                                                name="address"
                                                                required=""
                                                                disabled=""
                                                                placeholder={profile?.address}

                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-bold">{t("Company name")}</td>
                                                    <td>
                                                        <div className="flex-container">
                                                            <input
                                                                id='name_company'
                                                                className="form-control"
                                                                name="name_company"
                                                                required=""
                                                                disabled=""
                                                                placeholder={profile?.name_company}

                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-bold">{t("Tax code")}</td>
                                                    <td>
                                                        <div className="flex-container">
                                                            <input
                                                                id='taxcode'
                                                                className="form-control"
                                                                name="taxcode"
                                                                required=""
                                                                disabled=""
                                                                placeholder={profile?.taxcode}

                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr><td >* {t("Notify_email")}</td></tr>
                                                <tr>
                                                    <td className="text-bold">{t("Subemail")} 1</td>
                                                    <td>
                                                        <div className="flex-container">
                                                            <input
                                                                id='subemail1'
                                                                className="form-control"
                                                                name="subemail1"
                                                                required=""
                                                                disabled=""
                                                                placeholder={profile?.subemail1}

                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-bold">{t("Subemail")} 2</td>
                                                    <td>
                                                        <div className="flex-container">
                                                            <input
                                                                id='subemail2'
                                                                className="form-control"
                                                                name="subemail2"
                                                                required=""
                                                                disabled=""
                                                                placeholder={profile?.subemail2}

                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-bold">{t("Subemail")} 3</td>
                                                    <td>
                                                        <div className="flex-container">
                                                            <input
                                                                id='subemail3'
                                                                className="form-control"
                                                                name="subemail3"
                                                                required=""
                                                                disabled=""
                                                                placeholder={profile?.subemail3}

                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    )

                                }
                            </div>
                            <div className="m-4">
                                <button onClick={handleUpdateProfile} className="btn btn-primary">
                                    {t("Update information")}
                                </button>
                                {updateMessage && (
                                    <p style={{ color: "green", marginTop: "10px" }}>{updateMessage}</p>
                                )}
                            </div>

                        </div>
                        {" "}
                        <div className="tab-pane" id="tab_2" role="tabpanel">
                            {" "}
                            <div className="box-content-tab-default">
                                {" "}
                                <div className="card">
                                    {" "}
                                    <div className="card-body text-center">
                                        {" "}
                                        <div className="input-group">
                                            {" "}
                                            <input
                                                type="text"
                                                className="form-control input_gen_pass"
                                                disabled=""
                                                placeholder="Your new password will appear here ..."
                                            />{" "}
                                            <p id="input_gen_pass" style={{ display: "none" }} />{" "}
                                            <div
                                                className="btn btn-sm btn-primary"
                                                style={{ marginLeft: 5, paddingTop: 7, cursor: "pointer" }}
                                                data-toggle="tooltip"
                                                data-placement="right"
                                                data-original-title="Copy password"
                                                onclick="copyToClipboard('#input_gen_pass')"
                                            >
                                                {" "}
                                                <div className="fa fa-clone" />{" "}
                                            </div>{" "}
                                        </div>
                                        <br />{" "}
                                        <button className="btn btn-light" id="btn_gen_pass">
                                            {" "}
                                            Generate password{" "}
                                        </button>{" "}
                                    </div>{" "}
                                </div>{" "}
                                <form action="https://cloud.kdata.vn/user/account" method="POST">
                                    {" "}
                                    <input
                                        type="hidden"
                                        name="_token"
                                        defaultValue="YyXYMjyrkCpCmwO8r0xOCV5tBKiQbxHHCaDOb5NV"
                                        autoComplete="off"
                                    />{" "}
                                    <div className="form-group">
                                        {" "}
                                        <label htmlFor="password" className="text-center text-bold">
                                            Mật khẩu mới *
                                        </label>{" "}
                                        <input
                                            className="form-control"
                                            id="password"
                                            type="password"
                                            name="password"
                                            required=""
                                        />{" "}
                                    </div>{" "}
                                    <div className="form-group">
                                        {" "}
                                        <label htmlFor="password_confirm" className="text-center text-bold">
                                            Xác nhận mật khẩu *
                                        </label>{" "}
                                        <input
                                            className="form-control"
                                            id="password_confirm"
                                            type="password"
                                            name="password_confirm"
                                            required=""
                                        />{" "}
                                    </div>{" "}
                                    <div className="form-group">
                                        {" "}
                                        <div
                                            data-sitekey="6LdcR2UUAAAAAORI1qjywFtlyM_POKC7XIOE5clx"
                                            className="g-recaptcha"
                                        >
                                            <div style={{ width: 304, height: 78 }}>
                                                <div>
                                                    <iframe
                                                        title="reCAPTCHA"
                                                        width={304}
                                                        height={78}
                                                        role="presentation"
                                                        name="a-ridveah018fy"
                                                        frameBorder={0}
                                                        scrolling="no"
                                                        sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation allow-modals allow-popups-to-escape-sandbox allow-storage-access-by-user-activation"
                                                        src="https://www.google.com/recaptcha/api2/anchor?ar=1&k=6LdcR2UUAAAAAORI1qjywFtlyM_POKC7XIOE5clx&co=aHR0cHM6Ly9jbG91ZC5rZGF0YS52bjo0NDM.&hl=vi&v=pPK749sccDmVW_9DSeTMVvh2&size=normal&cb=swbchgkq4nkj"
                                                    />
                                                </div>
                                                <textarea
                                                    id="g-recaptcha-response"
                                                    name="g-recaptcha-response"
                                                    className="g-recaptcha-response"
                                                    style={{
                                                        width: 250,
                                                        height: 40,
                                                        border: "1px solid rgb(193, 193, 193)",
                                                        margin: "10px 25px",
                                                        padding: 0,
                                                        resize: "none",
                                                        display: "none"
                                                    }}
                                                    defaultValue={""}
                                                />
                                            </div>
                                            <iframe style={{ display: "none" }} />
                                        </div>{" "}
                                    </div>{" "}
                                    <div className="form-group pull-right" style={{ marginTop: 15 }}>
                                        {" "}
                                        <button className="btn bg-update-default" type="submit">
                                            {" "}
                                            <i className="fa fa-save" /> Lưu{" "}
                                        </button>{" "}
                                        <button className="btn bg-cancel-default" type="reset">
                                            {" "}
                                            <i className="fa fa-refresh" /> Làm mới{" "}
                                        </button>{" "}
                                    </div>{" "}
                                </form>{" "}
                                <div className="clearfix" />{" "}
                            </div>{" "}
                        </div>{" "}
                        <div className="tab-pane" id="tab_3" role="tabpanel">
                            {" "}
                            <div className="box-content-tab-default">
                                {" "}
                                <form action="https://cloud.kdata.vn/user/config" method="POST">
                                    {" "}
                                    <input
                                        type="hidden"
                                        name="_token"
                                        defaultValue="YyXYMjyrkCpCmwO8r0xOCV5tBKiQbxHHCaDOb5NV"
                                        autoComplete="off"
                                    />{" "}
                                    <div className="form-group">
                                        {" "}
                                        {/* Default unchecked */}{" "}
                                        <div className="custom-control custom-checkbox">
                                            {" "}
                                            <input
                                                type="checkbox"
                                                className="custom-control-input"
                                                defaultValue={1}
                                                id="get_warning"
                                                name="get_warning"
                                                defaultChecked=""
                                            />{" "}
                                            <label
                                                className="custom-control-label"
                                                style={{ cursor: "pointer", fontWeight: "bold" }}
                                                htmlFor="get_warning"
                                            >
                                                Nhận email cảnh báo hạn mức tiền trong tài khoản
                                            </label>{" "}
                                        </div>{" "}
                                    </div>{" "}
                                    <div className="form-group">
                                        {" "}
                                        <label htmlFor="payment_warning" className="text-center text-bold">
                                            Giới hạn cảnh báo tiền trong tài khoản (on Website) *
                                        </label>{" "}
                                        <input
                                            className="form-control"
                                            id="payment_warning"
                                            defaultValue={100000}
                                            type="text"
                                            name="payment_warning"
                                            required=""
                                        />{" "}
                                    </div>{" "}
                                    <div className="form-group pull-right" style={{ marginTop: 15 }}>
                                        {" "}
                                        <button className="btn bg-update-default" type="submit">
                                            {" "}
                                            <i className="fa fa-save" /> Lưu{" "}
                                        </button>{" "}
                                        <button className="btn bg-cancel-default" type="reset">
                                            {" "}
                                            <i className="fa fa-refresh" /> Làm mới{" "}
                                        </button>{" "}
                                    </div>{" "}
                                </form>{" "}
                                <div className="clearfix" />{" "}
                            </div>{" "}
                        </div>{" "}
                    </div>


                </div>
                <div className='col-5'>
                    <div className="text-center">
                        {" "}
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            height="250px"
                            width="250px"
                            version="1.1"
                            id="Layer_1"
                            viewBox="0 0 331.594 331.594"
                            xmlSpace="preserve"
                        >
                            <g id="XMLID_3_">
                                <g id="XMLID_62_">
                                    <g id="XMLID_1228_">
                                        <path
                                            id="XMLID_1229_"
                                            style={{ fill: "#F3D8B6" }}
                                            d="M248.986,236.042c-18.667-6.681-51.458-11.736-51.458-81.376h-29.23h-5.002     h-29.23c0,69.64-32.791,74.695-51.458,81.376c0,47.368,68.832,48.824,80.688,53.239v1.537c0,0,0.922-0.188,2.501-0.68     c1.579,0.492,2.501,0.68,2.501,0.68v-1.537C180.153,284.866,248.986,283.409,248.986,236.042z"
                                        />
                                    </g>
                                    <path
                                        id="XMLID_1230_"
                                        style={{ fill: "#EEC8A2" }}
                                        d="M197.528,154.666h-29.23h-2.501v135.472c1.579,0.491,2.501,0.68,2.501,0.68    v-1.537c11.856-4.414,80.688-5.871,80.688-53.239C230.319,229.361,197.528,224.306,197.528,154.666z"
                                    />
                                </g>
                                <g id="XMLID_55_">
                                    <path
                                        id="XMLID_1233_"
                                        style={{ fill: "#545465" }}
                                        d="M285.326,290.913v40.681H45.363v-40.681c0-30.431,17.377-56.963,40.605-70.913    c6.043-3.641,19.69-7.43,26.844-9.196c5.953-1.488,53.438,12.729,53.438,12.729s48.674-13.218,54.627-11.729    c7.154,1.766,17.802,4.554,23.844,8.196C267.949,233.951,285.326,260.482,285.326,290.913z"
                                    />
                                    <path
                                        id="XMLID_1236_"
                                        style={{ fill: "#494857" }}
                                        d="M245.627,220c-6.042-3.641-19.69-7.43-26.844-9.196    c-5.953-1.488-52.533,12.729-52.533,12.729l0,0v108.06h119.982v-40.681C286.232,260.482,268.854,233.951,245.627,220z"
                                    />
                                </g>
                                <g id="XMLID_52_">
                                    <path
                                        id="XMLID_1237_"
                                        style={{ fill: "#F3DBC4" }}
                                        d="M165.799,176.828c-27.454,0-48.409-23.119-57.799-40.456    s-15.888-79.445,4.34-106.897c19.808-26.883,53.459-13.838,53.459-13.838s33.649-13.045,53.458,13.838    c20.226,27.452,13.726,89.56,4.335,106.897C214.2,153.709,193.247,176.828,165.799,176.828z"
                                    />
                                    <path
                                        id="XMLID_1238_"
                                        style={{ fill: "#EDCEAE" }}
                                        d="M219.257,29.476c-19.81-26.883-53.458-13.838-53.458-13.838h-0.002v161.191    c0.001,0,0.001,0,0.002,0c27.449,0,48.401-23.119,57.794-40.456C232.983,119.036,239.483,56.928,219.257,29.476z"
                                    />
                                </g>
                                <g id="XMLID_45_">
                                    <path
                                        id="XMLID_1241_"
                                        style={{ fill: "#545465" }}
                                        d="M223.252,25.321c-2.159,0.08-12.282-31.303-39.282-24.303    c-18.537,4.806-20.877,7.419-28.12,9.463c-29.41-9.014-57.539,14.472-56.495,36.488c1.759,37.07-4.778,36.505-0.295,49.454    s8.466,23.407,8.466,23.407s0.996,3.565,2.988-16.854s-4.705-31.379,11.137-31.379c52.452,0-19.698,20.372,13.952,20.372    c33.391,0,59.203-27.381,74.92-29.372c15.716-1.992,9.145,19.96,11.137,40.379s2.988,16.854,2.988,16.854s8.92-9.712,8.466-23.407    C232.604,80.969,239.484,24.719,223.252,25.321z"
                                    />
                                    <path
                                        id="XMLID_1244_"
                                        style={{ fill: "#494857" }}
                                        d="M223.252,25.322c-2.159,0.08-12.282-31.303-39.282-24.303    c-9.171,2.377-14.375,4.218-18.173,5.719V85.04c18.973-8.253,34.142-21.103,44.726-22.443c15.717-1.992,9.145,19.96,11.137,40.379    s2.988,16.854,2.988,16.854s8.92-9.712,8.466-23.407C232.604,80.969,239.484,24.719,223.252,25.322z"
                                    />
                                </g>
                                <g id="XMLID_42_">
                                    <ellipse
                                        id="XMLID_44_"
                                        transform="matrix(0.3543 -0.9351 0.9351 0.3543 45.161 283.6375)"
                                        style={{ fill: "#EDCEAE" }}
                                        cx="227.971"
                                        cy="109.116"
                                        rx="17.187"
                                        ry="10.048"
                                    />
                                    <ellipse
                                        id="XMLID_43_"
                                        transform="matrix(0.3543 0.9351 -0.9351 0.3543 168.9501 -26.4359)"
                                        style={{ fill: "#F3DBC4" }}
                                        cx="103.618"
                                        cy="109.124"
                                        rx="17.187"
                                        ry="10.048"
                                    />
                                </g>
                                <g id="XMLID_38_">
                                    <g id="XMLID_1245_">
                                        <polygon
                                            id="XMLID_1246_"
                                            style={{ fill: "#FFFFFF" }}
                                            points="213.458,331.594 118.136,331.594 118.136,204.664 165.797,218.388      213.458,204.664    "
                                        />
                                    </g>
                                    <polygon
                                        id="XMLID_1247_"
                                        style={{ fill: "#DFE0E7" }}
                                        points="165.797,218.388 165.797,331.594 213.458,331.594 213.458,204.664   "
                                    />
                                </g>
                                <g id="XMLID_4_">
                                    <path
                                        id="XMLID_35_"
                                        style={{ fill: "#494857" }}
                                        d="M126.777,201.164c0,0-32.452,8.501-39.684,18.626    c-7.232,10.124-11.571,23.865-11.571,23.865l28.204,10.124l-20.887,20.344l28.811,57.366h26.791c0,0-20.868-72.454-21.331-97.992    C116.959,225.13,126.777,201.164,126.777,201.164z"
                                    />
                                    <path
                                        id="XMLID_1251_"
                                        style={{ fill: "#3B3A47" }}
                                        d="M204.817,201.164c0,0,32.452,8.501,39.684,18.626    c7.232,10.124,11.571,23.865,11.571,23.865l-28.204,10.124l20.887,20.344l-28.15,57.366h-26.791c0,0,20.207-72.454,20.669-97.992    C214.635,225.13,204.817,201.164,204.817,201.164z"
                                    />
                                </g>
                            </g>
                        </svg>

                        <br />
                        <br />                                     {t("Update information")}
                        {" "}
                    </div>

                </div>
            </div>
        </>
    );
}

export default ProfileForm;
